import React, { useEffect, useState } from 'react';
import '../../css/steps.css';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Onboarding_Seo from '../../SEO/Onboarding_Seo';

function Onboarding() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Onboarding_Seo />
                    <Header />
                    {/* Internal CSS */}
                    <style>
                        {`
                            .cardcss {
                                    box-shadow: 0 5px 40px 0 rgba(0,0,0,.11);
                                    margin: 0 0 20px 0
                                }
                        `}
                    </style>
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Onboarding</h1>
                                <ul>
                                    <li><NavLink to="/help">Help</NavLink></li>
                                    <li>KYC Upload</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}
                    {/* Onboarding section start */}
                    <div className="ptb-100">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                    <div className="card px-0 pb-0 mb-3">
                                        <h2 id="heading">KYC Documents Upload</h2>
                                        <p className="mt-2">On our mobile app to complete your onboarding process we require your Photo ID and a selfie. We use ID Scan solution which takes less than a minute to complete this for you. </p>
                                        <div id="msform">
                                            {/* progressbar */}
                                            <ul id="progressbar">
                                                <NavLink to="/onboarding">
                                                    <li className="active" id="confirm"><strong>1) Scanning Your Id</strong></li>
                                                </NavLink>
                                                <NavLink to="/livenesscheck">
                                                    <li id="confirm"><strong>2) Liveness Check</strong></li>
                                                </NavLink>
                                                <NavLink to="/finish">
                                                    <li id="confirm"><strong>Finish</strong></li>
                                                </NavLink>
                                            </ul>
                                            {/* fieldsets */}
                                            <fieldset>
                                                <div className="form-card">
                                                    <div className="row justify-content-center">
                                                        <h4 className="mb-4">How To Scan Id?</h4>
                                                    </div>
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/scanid1.png" alt="How to scan Id?" />
                                                                <div className="card-body">
                                                                    <p className="card-text">Try not to take the photo from any other angle. It will work regardless, but parallel is better.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/scanid2.png" alt="How to scan Id?" />
                                                                <div className="card-body">
                                                                    <p className="card-text">Try not to take the photo from any other angle. It will work regardless, but parallel is better.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className="hrcss" />
                                                    <div className="row justify-content-center">
                                                        <h4 className="mb-4 mt-2">What to avoid?</h4>
                                                    </div>
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/scanid4.png" alt=" What to avoid?" />
                                                                <div className="card-body">
                                                                    <p className="card-text">Please avoid flash or glares.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/scanid6.png" alt=" What to avoid?" />
                                                                <div className="card-body">
                                                                    <p className="card-text">Please avoid shadows over the ID.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/scanid7.png" alt=" What to avoid?" />
                                                                <div className="card-body">
                                                                    <p className="card-text">Please remove any background clutter.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/scanid3.png" alt=" What to avoid?" />
                                                                <div className="card-body">
                                                                    <p className="card-text">Please make sure your details aren't blurry.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/scanid5.png" alt=" What to avoid?" />
                                                                <div className="card-body">
                                                                    <p className="card-text">Please make sure you are not cropping or skewing the ID.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <NavLink to="/livenesscheck" type="button" className="next action-button">Next</NavLink>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Onboarding section end */}
                    {/* Footer Section Here */}
                    <Footer />
                </>
            )}
        </div>
    );
}

export default Onboarding
